module.exports = __webpack_public_path__ + "static/media/travicar_eletrostatico_bico_LEQUE.5a238e23.png";